import { FiscalYearsActionTypes } from './action-types';
import { FiscalYearsRes } from 'models';

export const setFiscalYears = (res: FiscalYearsRes, coopId: string) =>
  ({
    type: FiscalYearsActionTypes.SET_FISCAL_YEARS,
    payload: { res, coopId },
  } as const);
